// src/components/Booking.jsx
import React from 'react';

/* ---- Helpers ---- */

const formatTime = (timeString) => {
  if (!timeString) return '';
  try {
    if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeString)) {
      const [hh, mm] = timeString.split(':');
      return `${hh}:${mm}`;
    }
    return timeString;
  } catch {
    return timeString;
  }
};

const calculateDuration = (start, end) => {
  try {
    if (!start || !end) return '';
    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = end.split(':').map(Number);
    const startTotal = sh * 60 + sm;
    const endTotal = eh * 60 + em;
    const minutes = endTotal < startTotal ? endTotal + 24 * 60 - startTotal : endTotal - startTotal;
    if (minutes <= 0) return '';
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h && m) return `${h}h ${m}m`;
    if (h) return `${h}h`;
    return `${m}m`;
  } catch {
    return '';
  }
};

const sessionModifier = (type) => {
  switch ((type || '').toLowerCase()) {
    case 'training':    return 'sch-booking--training';
    case 'match':       return 'sch-booking--match';
    case 'maintenance': return 'sch-booking--maintenance';
    case 'event':       return 'sch-booking--event';
    default:            return '';
  }
};

/* ---- Component ---- */

const Booking = ({ booking, onDelete }) => {
  const modifier = sessionModifier(booking.session_type);
  const pitchName = booking.pitch_name || `Facility #${booking.pitch_id}`;
  const isHalf =
    booking.pitch_portion && booking.pitch_portion !== 'full' && pitchName !== 'Gym';
  const coach = booking.coach_name;
  const duration = calculateDuration(booking.start_time, booking.end_time);

  return (
    <article className={`sch-booking ${modifier}`}>
      <div className="sch-booking-time">
        <div className="sch-booking-start">{formatTime(booking.start_time)}</div>
        <div className="sch-booking-end">{formatTime(booking.end_time)}</div>
        {duration && <div className="sch-booking-duration">{duration}</div>}
      </div>

      <div className="sch-booking-main">
        <div className="sch-booking-tags">
          <span className="sch-booking-type">
            {booking.session_type || 'Session'}
          </span>
          {isHalf && <span className="sch-booking-portion">Half pitch</span>}
        </div>

        <h3 className="sch-booking-pitch">{pitchName}</h3>

        {coach && (
          <div className="sch-booking-coach">
            <em>with</em> <strong>{coach}</strong>
          </div>
        )}

        {booking.notes && (
          <div className="sch-booking-notes">"{booking.notes}"</div>
        )}
      </div>

      <div className="sch-booking-actions">
        {onDelete && (
          <button
            type="button"
            className="sch-booking-action"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(booking.id);
            }}
            aria-label="Delete booking"
            title="Delete booking"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <path d="M10 11v6" />
              <path d="M14 11v6" />
              <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
            </svg>
          </button>
        )}
      </div>
    </article>
  );
};

export default Booking;
